import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Button, TextInput, Label } from "./FormElements";
import { BodyCopySmall } from "./styles/TextStyles";

export default function Subscribe() {
  // 1. Create a reference to the input so we can fetch/clear it's value.
  const inputEl = useRef(null);
  // 2. Hold a message in state to handle the response from our API.
  const [message, setMessage] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();

    // 3. Send a request to our API with the user's email address.
    const res = await fetch("/api/subscribe", {
      body: JSON.stringify({
        email: inputEl.current.value,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });

    const { error } = await res.json();

    if (error) {
      // 4. If there was an error, update the message in state.
      setMessage(error);

      return;
    }

    // 5. Clear the input value and show a success message.
    inputEl.current.value = "";
    setMessage("Success! You're on the list.");
  };

  return (
    <Form onSubmit={subscribe}>
      <BodyCopySmall>
        {message ? message : "Be the first to know when new collections drop."}
      </BodyCopySmall>
      <br />
      {/* <Label htmlFor="email-input">
        {"Email Address"}
      </Label> */}
      <TextInput
        id="email-input"
        name="email"
        placeholder="you@internet.com"
        ref={inputEl}
        required
        type="email"
      />

      <Button type="submit">{"Subscribe"}</Button>
    </Form>
  );
}

const Form = styled.form`
  grid-column: 1 / -1;

  text-align: center;

  @media screen and (min-width: 768px) {
    grid-column: 4 / span 6;
  }
`;
